import {ColumnDef} from '@tanstack/react-table';
import {DataTableColumnHeader} from "@/components/data-table/data-table-column-header.tsx";
import {RequestAndAvailability} from "@/types/RequestOverview.ts";
import {AllCriteria} from "@/types/Criteria.ts";
import {getCriteriaValue, keyValueMapping} from "@/utils/criteria-helper.tsx";
import {TFunction} from "i18next";

export const getRequestsAvailabilitiesColumns = (
    criteria: AllCriteria | undefined,
    t: TFunction
): ColumnDef<RequestAndAvailability>[] => [
    {
        id: "criteria",
        accessorFn: row => {
            const mapping = keyValueMapping[row.key];
            return mapping ? t(`criteria.${mapping.label}`) : row.key;
        },
        header: ({column}) => (
            <DataTableColumnHeader column={column} title="criteria"/>
        ),
        filterFn: (row, id, value) => {
            return String(value) === row.getValue(id);
        },
        enableHiding: false,
    },
    {
        id: "value",
        accessorFn: row => getCriteriaValue(criteria, row.key, row.value),
        header: ({column}) => (
            <DataTableColumnHeader column={column} title="value"/>
        ),
        filterFn: (row, id, value) => {
            return String(value) === row.getValue(id);
        },
        enableHiding: false,
    },
    {
        id: "requests",
        accessorFn: row => `${row.requests} (${row.requestPercentage}%)`,
        header: ({column}) => (
            <DataTableColumnHeader column={column} title="numOfPreferences"/>
        ),
        enableHiding: false,
    },
    {
        id: "mentors",
        accessorFn: row => `${row.mentors} (${row.mentorPercentage}%)`,
        header: ({column}) => (
            <DataTableColumnHeader column={column} title="numOfMentors"/>
        ),
        cell: ({row}) => {
            return (
                <div className="flex items-center">
                    <span className={row.original.mentors === 0 ? 'text-tangerine' : ''}>
                        {row.original.mentors} ({row.original.mentorPercentage}%)
                    </span>
                </div>
            );
        },
        enableHiding: false,
    },
    {
        id: "gap",
        accessorFn: row => row.mentorPercentage - row.requestPercentage,
        header: ({column}) => (
            <DataTableColumnHeader column={column} title="gap"/>
        ),
        cell: ({ row }) => {
            const gap = row.original.mentorPercentage - row.original.requestPercentage;
            return (
                <div className="flex items-center">
                    <span className={gap < 0 ? 'text-tangerine' : ''}>
                        {gap}
                    </span>
                </div>
            );
        },
    },
]
